import { SrfJanrain } from './classes/SrfJanrain';

export function init() {
  initJanrain();
}
// hack for janrain-init
window.$ = $;

function initJanrain() {
  import('./janrain-init').then(() => {
    return import('./janrain-utils.js').then(() => {
      new SrfJanrain();
    });
  });
}
